module.exports = __webpack_public_path__ + "img/main-list_04.4521a217.jpg";